<template>
  <button class="button --secondary --nav" @click="share">{{ $t('share.button') }}</button>
  <Transition name="fade-fast">
    <Loader v-if="sharing" share />
  </Transition>
</template>

<script>
import { base64ToBlob } from '@/helpers'

import Loader from './Loader.vue'

export default {
  name: 'Share',
  components: { Loader },
  data() {
    return {
      sharing: false,
    }
  },
  methods: {
    async getFiles() {
      const data = await this.$store.dispatch('fetchShareImage')
      if (!data.image) return []

      const mimeType = 'image/jpeg'
      const image = base64ToBlob(data.image, mimeType)
      return [
        new File([image], 'magie-des-farfadets.jpg', {
          type: mimeType,
          lastModified: new Date().getTime(),
        }),
      ]
    },
    async share() {
      this.sharing = true
      const siteLink = window?.location?.origin ?? 'https://magiedesfarfadets.com'
      let baseData = {
        text: `${this.$t('share.description')} ${siteLink}`,
        title: this.$t('share.title'),
      }

      const files = await this.getFiles()
      const dataWithFiles = {
        ...baseData,
        files: files,
      }

      let data = null
      if (navigator.canShare(dataWithFiles)) {
        data = dataWithFiles
      } else if (navigator.canShare(baseData)) {
        data = baseData
      } else {
        alert(this.$t('cant_share'))
      }

      if (data) {
        try {
          await navigator.share(data)
        } catch (e) {
          //
        }
      }

      this.sharing = false
    },
  },
}
</script>
